import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Container, Row, Col, Card, Button, Spinner } from 'react-bootstrap';
import PageTitle from '../../common/PageTitle';
import { useUser } from '../../../context/UserContext';

const Logout = () => {
  const { handleLogout } = useUser();
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleCancel = () => {
    navigate('/main');
  }

  const handleSubmit = () => {
    setLoading(true);
    handleLogout();
  }

  return (
    <>
      <Container>
        <Row>
          <Col>
            <PageTitle text='sair' />
          </Col>
        </Row>
      </Container>
      <Container>
        <Row>
          <Col md={8}>
            <Card>
              <Card.Body>
                <Card.Text>Tem certeza que deseja sair?</Card.Text>
              </Card.Body>
            </Card>
          </Col>
        </Row>
        <Row>
          <Col className='mt-2'>
            <Button variant="primary" onClick={handleCancel}>Não</Button>
            <Button variant="secondary" className='mx-2' onClick={handleSubmit} disabled={loading}>
              {loading ? <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" /> : 'Sim'}
            </Button>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default Logout;